if ($(window.location.hash).offset()) {
  $('html,body').animate({
    scrollTop: $(window.location.hash).offset().top - 100
  });
}


$(document).scroll(function() {
  createSlideEffect($(".bikes-mega-img"))
  //createSlideEffect($(".bikes-background-slogan .bikes-container"))
});

function createSlideEffect($element) {
  var scroll = $(window).scrollTop();
  if ($element.length) {
    var heightElement = $element.offset().top;
    var finalOffset = -100 + ((scroll - heightElement + 300 ) * 0.3) + "px";
    $element.css("background-position-y", finalOffset );
  }
}




$(window).on('load', function () {
  showTableQuestion('.bikes-question')
})


function showTableQuestion(selectorNav) {
  $(selectorNav).click(function () {
    var content = $(this).closest("li").find(".bikes-answer");
    if (content.css('max-height') != '0px' ){
      content.css('max-height', '0px');
    } else {
      content.css('max-height', content[0].scrollHeight + "px");
    }
  })
}

if(window.location.pathname.includes('/cart') || window.location.pathname.includes('account/')) {
  setFixedHeader();
}

$(window).scroll(function() {
    if ($(window).scrollTop() > 100){
      setFixedHeader();
    } else {
      setStaticHeader();
    }
});

function setFixedHeader() {
  $("#shopify-section-static-header").css({
    position: 'fixed',
    top: 0,
    background: '#071B32'
  })

  $("#shopify-section-static-header .main-header").css({
      top: '0px'
  })
}

function setStaticHeader() {
  var top = '37px';
  if (window.location.pathname != '/') {
    top = 0;
  }
  if (!window.location.pathname.includes('/cart') && !window.location.pathname.includes('account/')) {
    $("#shopify-section-static-header").css({
      position: 'absolute',
      top: top,
      background: '#071B32'
    })
    $("#shopify-section-static-header .main-header").css({
        top: '0px'
    })
  }
}




$(window).on('load', function () {
  selectColorCarousel();
  showModalBikesSelection('#shopify-section-bikes-static-product .bikes-cta-order', '.bikes-order-checkout');
  closeModalBikesSelection('#shopify-section-bikes-static-product .bikes-close-modal', '.bikes-order-checkout');
  showModalBikesSelection('.bikes-cta-pre-order', '.bikes-preorder-checkout');
  closeModalBikesSelection('.bikes-preorder-checkout .bikes-close-modal', '.bikes-preorder-checkout');
  addProductToCart();
//   showTableCategory('.bikes-nav-table div:first-child', '.bikes-content > .bikes-content-1')
})

function selectColorCarousel() {
  var colorButton = $('.bikes-select-color button');
  var oldPrice = colorButton.attr('data-old-price');
  var price = colorButton.attr('data-price');
  $('.bikes-old-price').text(oldPrice)
  $('.bikes-real-price').text(price);
  colorButton.click(function () {
    var selectedColor = $(this).attr('data-select-color');
    $("#bikes-static-product .bikes-carousel").each(function () {
      var sliderOfThisColor = $(this).attr('data-select-color');
      if (selectedColor != sliderOfThisColor) {
        $(this).css({position: 'absolute',
        opacity: 0,
        "z-index": -1,
        '-webkit-transition': 'opacity 0s ease-in-out',
            '-moz-transition': 'opacity 0s ease-in-out',
            '-ms-transition': 'opacity 0s ease-in-out',
            '-o-transition': 'opacity 0s ease-in-out'
        })
      } else {
        $(this).css({position: 'relative',
        opacity: 1,
        "z-index": "inherit",
        '-webkit-transition': 'opacity 0.6s ease-in-out',
            '-moz-transition': 'opacity 0.6s ease-in-out',
            '-ms-transition': 'opacity 0.6s ease-in-out',
            '-o-transition': 'opacity 0.6s ease-in-out'
        })
      }
    })
  })
}

function showModalBikesSelection(selector, modalSelector) {
  $(selector).click(function () {
    $(modalSelector).css({display: 'block'});
    $('#shopify-section-static-header').css({opacity: 0});
    setTimeout(function () {
      $(modalSelector).css({opacity: 1});
    }, 30)
    setTimeout(function () {
      $('#shopify-section-static-header').css('position', 'absolute')
    }, 600)
  })
}

function closeModalBikesSelection(selector, modalSelector) {
  $(selector).click(function () {
    $(modalSelector).css({opacity: 0});
    $('#shopify-section-static-header').css({opacity: 1});
    $('#shopify-section-static-header').css('position', 'fixed')
    setTimeout(function () {
      $(modalSelector).css({display: 'none'});
    }, 600)
  })
}

function addProductToCart() {
  $('.bikes-order-checkout-selection').click(function () {
    var id = $(this).attr('data-variant-id');
    jQuery.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: {
        items: [{
          quantity: 1,
          id: id
        }]
      },
      success: function (response) {
        if (response.items.length) {
          window.location.replace('/checkout');
        }
      },
      dataType: 'json'
    });
  })
}

function showTableCategory(selectorNav, selectShowContent) {
//   $(selectorNav).click(function () {
    var content = document.querySelector(selectShowContent);
    if (content.style.maxHeight){
      content.style.maxHeight = null;
      if ($(window).width() <= 580) {
        $(selectorNav).css('font-weight', 'normal');
      }
      // $(selectorNav + ' span:last-child').css('opacity', 0)
      // $(selectorNav + ' span:first-child').css('webkitAnimationName', 'downLogoTextBis');
    } else {
      if ($(window).width() <= 580) {
        $(selectorNav).css('font-weight', 'bold');
      }
      // $(selectorNav + ' span:first-child').css('webkitAnimationName', 'upLogoTextBis');
      // $(selectorNav + ' span:last-child').css('opacity', 1)
//       setTimeout(function () {
        content.style.maxHeight = content.scrollHeight + "px";
//       }, 300)
    }
//   })
}
